/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ProfitDto,
    ProfitDtoFromJSON,
    ProfitDtoToJSON,
} from '../models';

/**
 * 
 */
export class ProfitsApi extends runtime.BaseAPI {

    /**
     * Get profits by months
     */
    async profitControllerGetProfitsByMonthsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<ProfitDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/profits`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfitDtoFromJSON(jsonValue));
    }

    /**
     * Get profits by months
     */
    async profitControllerGetProfitsByMonths(initOverrides?: RequestInit): Promise<ProfitDto> {
        const response = await this.profitControllerGetProfitsByMonthsRaw(initOverrides);
        return await response.value();
    }

}
